import IframeVideoView from "./../view/iframe-video.js";
import {render} from "./../../render/render.js";
import {ObserverOption} from "./../const.js";

export default class IframeVideo {
  constructor(container, url) {
    this._container = container;
    this._url = url;

    this._view = new IframeVideoView(this._url);
  }

  init() {
    const observerCallback = (entries, observer) => {
      let isIntersecting = false;

      entries.forEach((entry) => {
        if (isIntersecting === true) {
          return;
        }

        isIntersecting = entry.isIntersecting;
      });

      if (isIntersecting === false) {
        return;
      }

      observer.unobserve(this._container);

      const videoElement = this._view.getElement();
      render(this._container, videoElement);
    };

    const observer = new IntersectionObserver(observerCallback, ObserverOption);
    observer.observe(this._container);
  }
}
